import { render } from "./ReviewsComponent.vue?vue&type=template&id=57bf9b36&scoped=true"
import script from "./ReviewsComponent.vue?vue&type=script&lang=js"
export * from "./ReviewsComponent.vue?vue&type=script&lang=js"

import "./ReviewsComponent.vue?vue&type=style&index=0&id=57bf9b36&scoped=true&lang=css"

import exportComponent from "/builds/pazzei/pazzei-landing/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57bf9b36"]])

export default __exports__